import classNames from "classnames";
import css from "./style.module.scss";
import React from "react";
import { NavBar } from "../../components/NavBar/NavBar";
import { Footer } from "../../components/Footer/Footer";
import { isDevEnvironment } from "../../utils/common";
import { GetServerSideProps } from "next";
import { useIsPageAllowed } from "../../hooks/useIsPageAllowed";
import { Domain } from "../../types/common";
import { useRouter } from "next/router";

function IndexPage({ host }: { host: string }) {
  const isDev = isDevEnvironment(host);
  const router = useRouter();
  if (!useIsPageAllowed([Domain.MEDIENECKE], host)) return false;

  return (
    <div className={classNames(css["page-layout"])}>
      <NavBar isDev={isDev} domain={Domain.MEDIENECKE} />
      <div className={classNames(css["main-layout"])}>
        <div className={classNames(css["content"])}>
          <button onClick={() => router.back()}>Zurück</button>
          <h1>Qualitätskriterien</h1>
          <p>
            Die MEDIENECKE ist das OER-Portal des KITA HUB Bayern, das digitale,
            interaktive Angebot des Staatsinstituts für Frühpädagogik und
            Medienkompetenz (IFP).
          </p>
          <p>
            In die MEDIENECKE wird eine Vielzahl von Materialien hochgeladen,
            die Fachkräfte in der Frühpädagogik in ihrer alltäglichen Arbeit
            unterstützen sollen. Dabei soll eine breitgefächerte
            Materialvielfalt entstehen, welche in die einzelnen Themensammlungen
            der MEDIENECKE geordnet wird.
          </p>
          <p>
            Damit ein Material auf der MEDIENECKE veröffentlicht wird, muss es
            Qualitätsmerkmale erfüllen, die von unserer Redaktion geprüft
            werden.
          </p>
          <p>
            Folgende Kriterien werden vor der Veröffentlichung eines Materials
            in der MEDIENECKE berücksichtigt:
          </p>
          <p>
            <b>Formale Qualität</b>
            <br />
            Im Vorfeld muss die formale Qualität geprüft werden. Materialien
            müssen sachlich richtig, vollständig, sowie in Rechtschreibung und
            Grammatik korrekt sein. Weiter ist zu berücksichtigen, dass Belege,
            Quellen-/Literaturangaben und Weblinks angegeben, beziehungsweise
            verfügbar sind. Sie müssen zeitgemäß, sowie zielgruppenspezifisch
            und diversitätssensibel verfasst sein.
            <br />
            Da in der MEDIENECKE ausschließlich OER-Materialien verwendet
            werden, ist eine CC-Lizensierung mit dem entsprechenden Hinweis
            erforderlich.
            <br />
            Das Material darf in keiner Weise pornografische,
            gewaltverherrlichende, obszöne, diffamierende, verletzende,
            bedrohende, beleidigende oder verleumderische Inhalte oder Aussagen
            enthalten oder in jeglichem Zusammenhang damit stehen.
            <br />
            Auch aus technischer Sicht werden die Materialien überprüft, sodass
            keine Dateien und Inhalte auf die MEDIENECKE gelangen, die Viren,
            Fehler, Manipulationen oder anderen schädigende Elementen
            beinhalten.
          </p>
          <p>
            <b>Inhaltliche Qualität</b>
            <br />
            Alle Materialien in der MEDIENECKE müssen inhaltlich korrekt und
            aktuell sein. Sie sollen in erster Linie an Fachkräfte der
            Frühpädagogik adressiert und auf deren Bedarfe abgestimmt sein. Der
            Inhalt soll für die Zielgruppe verständlich und relevant erscheinen
            sowie schlüssig und logisch aufgebaut sein. Auch ist eine korrekte
            (fach-)wissenschaftliche Fundierung zu berücksichtigen.
          </p>
          <p>
            <b>Wiederverwendbarkeit</b>
            <br />
            Die eingestellten Materialien werden auf der MEDIENECKE
            veröffentlicht, um wiederverwendet und der Öffentlichkeit zur
            Verfügung gestellt zu werden.
            <br />
            Für die Veröffentlichung auf der MEDIENECKE muss ein Material über
            eine OER-Lizenz verfügen. Da wir großen Wert auf die freie,
            uneingeschränkte Verwendbarkeit und die weitere Nutzung der
            Materialien in der Praxis legen, vergeben wir für interne
            Materialien ausschließlich die Lizenzen CC0 und CC BY, bei externen
            Materialien fällt die Wahl bis zur Lizenz CC BY-SA.
            <br />
            Grundsätzlich gilt für alle OER-Materialien ein transparenter
            Verweis auf verwendete Datenquellen, die für die Erstellung
            herangezogen wurden. Materialien sollen objektiv, reliabel und
            valide sein.
          </p>

          <p>
            <b>Unterstützung und Transfer</b>
            <br />
            Die Materialien in der MEDIENECKE sollen so erstellt und angelegt
            werden, dass sie praxisnah und in Alltagssituationen angewendet
            werden können. Sie sollten dabei als Unterstützung und Anregung für
            die Frühpädagogik dienen und ein Angebot zur Ergänzung der
            pädagogischen Tätigkeit darstellen. Sie sind nicht als
            handlungsweisend anzusehen. Für die vollständige Ausgestaltung des
            tatsächlichen pädagogischen Settings ist jede:r Nutzende selbst
            zuständig und verantwortlich.
          </p>
          <p>
            Die Qualitätskriterien der MEDIENECKE wurden entworfen auf Basis von
            „Qualität von OER - Internationale Bestandsaufnahme von Instrumenten
            zur Qualitätssicherung von Open Educational Resources (OER) –
            Schritte zu einem deutschen Modell am Beispiel der Hamburg Open
            Online University“ von Olaf Zawacki-Richter, Kerstin Mayrberger
            (2017) unter CC BY.
          </p>
        </div>
      </div>
      <div>
        <Footer domain={Domain.MEDIENECKE} />
      </div>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const host = context?.req?.headers?.host || null;

  return {
    props: { host },
  };
};

export default IndexPage;
